import { render } from "./Selection.vue?vue&type=template&id=5dfccdd2"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"
script.render = render

export default script